import { sentry, tracker } from '@affine/track';
import { APP_SETTINGS_STORAGE_KEY } from '@toeverything/infra/atom';

// Diagnostics are opt-in. An unavailable or malformed preference must not
// prevent the private installation from starting.
let enabled = false;
try {
  const settingsStr = localStorage.getItem(APP_SETTINGS_STORAGE_KEY);
  enabled = settingsStr
    ? JSON.parse(settingsStr).enableTelemetry === true
    : false;
} catch {
  // Keep the privacy-preserving default when storage cannot be read.
}

tracker.init();
if (enabled) {
  sentry.init();
} else {
  sentry.disable();
  tracker.opt_out_tracking();
}
